import {InitPage} from "../index";
import {ImportFile} from "../common/import_file";
import {ElcEmployeePrinting} from "./employee_printing";
import axios from "axios";

class ElcEmployees {
    constructor() {
        const _this = this;

        this.initializeHTML();

        $("select#elc_employee_employee_type_id").change(function(e){
          _this.set_add_tempagency();
          _this.set_add_rateprofile();
        });

        InitPage("employees edit update create", () => {
            _this.set_edit_tempagency();
            _this.set_edit_rateprofile();
            _this.set_edit_rateprofile_tempagency();
        });

        InitPage("new", () => {
            _this.set_add_rateprofile_tempagency();
        });

        InitPage("index", () => {
            _this.setCheckAll();
            let import_file = new ImportFile();
            let elc_printing = new ElcEmployeePrinting();

            // Initialize remember reader functionality (we need to know last printer_id)
            $("#selectedPrinter").on("change", (e) => {
                axios.get(`save_selected_printer.json`, { params: { id: $(e.target).val() } });
            });
        })
    }

    initializeHTML() {
        $("select#elc_employee_rate_profile_id").change(function(e){
            var rateValue = $(this).find(":selected").attr("data-rate");
            if(rateValue)
              $("#rateProfilePrice").text("$" + rateValue);
            else
              $("#rateProfilePrice").text("");

        });

        $("select#elc_employee_temp_agency_id").change(function(){
            var rateProfileID = $("#elc_employee_temp_agency_id").find(":selected").attr("data-rateprofile_id");
            $("#elc_employee_rate_profile_id option[value="+rateProfileID+"]").prop("selected",true);
            var rateValue = $("#elc_employee_temp_agency_id").find(":selected").attr("data-rate");
            if(rateValue)
              $("#rateProfilePrice").text("$" + rateValue);
            else
              $("#rateProfilePrice").text("");
        });
    }

    setCheckAll() {
        $("#checkAll").on("click", function(){
            $.each($(".employee_tag"), function(){
                $(this).prop("checked", $("#checkAll").is(":checked"));
            });
        });
    }

    set_add_tempagency() {
        var typeValue = $("select#elc_employee_employee_type_id").find(":selected").attr("data-type");
        if(typeValue == "Permanent")
        {
          $("#elc_employee_temp_agency_id").removeAttr("required");
          $("#elc_employee_temp_agency_id option:first").attr("value",0);
          $("#elc_employee_temp_agency_id").find(":selected").removeAttr("selected");
          $("#elc_employee_temp_agency_id option:first").attr("selected","selected");
          $("#elc_employee_temp_agency_id").attr("readonly", "true");
          $("#elc_employee_temp_agency_id").attr("style", "pointer-events: none;");
        }
        else
        {
          $("#elc_employee_temp_agency_id option:first").attr("value","");
          $("#elc_employee_temp_agency_id option:first").prop("selected",true);
          $("#elc_employee_temp_agency_id").removeAttr("readonly");
          $("#elc_employee_temp_agency_id").removeAttr("style");
          $("#elc_employee_temp_agency_id").attr("required", "required");
        }
    }

    set_edit_tempagency() {
        var typeValue = $("select#elc_employee_employee_type_id").find(":selected").attr("data-type");
        if(typeValue == "Permanent")
        {
          $("#elc_employee_temp_agency_id").removeAttr("required");
          $("#elc_employee_temp_agency_id option:first").attr("value",0);
          $("#elc_employee_temp_agency_id").find(":selected").removeAttr("selected");
          $("#elc_employee_temp_agency_id option:first").attr("selected","selected");
          $("#elc_employee_temp_agency_id").attr("readonly", "true");
          $("#elc_employee_temp_agency_id").attr("style", "pointer-events: none;");
        }

    }


    set_add_rateprofile() {
        var employeeType = $("select#elc_employee_employee_type_id").find(":selected").attr("data-type");
        var rateProfileType = "";
        var currentItem;
        if(employeeType) {
            if(employeeType == "Permanent")
                rateProfileType = "Employee";
            else
                rateProfileType = "Agency";

            $("#elc_employee_rate_profile_id option").each(function() {
                currentItem = $(this).attr("data-type");
                if(currentItem != rateProfileType )
                {
                    $(this).removeAttr("selected");
                    $(this).hide();
                    $(this).prop("disabled","disabled");
                }
                else
                {
                    $(this).show();
                    $(this).removeAttr("disabled");
                    if($(this).attr("data-default") == "true"){
                        $(this).prop("selected", true);
                        var rateValue = $(this).attr("data-rate");
                        if(rateValue)
                            $("#rateProfilePrice").text("$" + rateValue);
                        else
                            $("#rateProfilePrice").text("");
                    }
                    else
                        $(this).removeAttr("selected");
                }
            });
        }
        else{
            $("select#elc_employee_rate_profile_id option").each(function() {
                $(this).show();
                $(this).removeAttr("disabled");
                $(this).removeAttr("selected");
                $("#rateProfilePrice").text("");
            });
        }
    }

    set_edit_rateprofile(){
        var employeeType = $("select#elc_employee_employee_type_id").find(":selected").attr("data-type");
        var rateProfileType = "";
        var currentItem;

        if(employeeType)
        {
            if(employeeType == "Permanent")
                rateProfileType = "Employee";
            else
                rateProfileType = "Agency";
            $("#elc_employee_rate_profile_id option").each(function() {
                currentItem = $(this).attr("data-type");
                if(currentItem != rateProfileType )
                {
                    $(this).removeAttr("selected");
                    $(this).hide();
                    $(this).prop("disabled","disabled");
                }
                else
                {
                    $(this).show();
                    $(this).removeAttr("disabled");
                }
            });
            var rateValue = $("#elc_employee_rate_profile_id").find(":selected").attr("data-rate");
            $("#rateProfilePrice").text("$" + rateValue);
        }
    }

    set_add_rateprofile_tempagency(){
        var empTypeID = $("input#elc_employee_temp_agency_id").val();
        var rateValue = $("input#elc_employee_temp_agency_id").attr('data-rate');
        var currentItem;
        if(empTypeID)
        {
            $("#elc_employee_rate_profile_id option").each(function() {
                currentItem = $(this).attr("data-type");
                if(currentItem != "Agency" )
                {
                    $(this).removeAttr("selected");
                    $(this).hide();
                    $(this).prop("disabled","disabled");
                }
                else
                {
                    $(this).show();
                    $(this).removeAttr("disabled");
                    if($(this).attr("data-rate") == rateValue)
                    {
                        $(this).prop("selected", true);
                        $("#rateProfilePrice").text("$" + rateValue);
                    }
                    else
                    {
                        $(this).removeAttr("selected");
                    }
                }
            });
        }
    }

    set_edit_rateprofile_tempagency(){
        var empTypeID = $("input#elc_employee_temp_agency_id").val();
        var currentItem;
        if(empTypeID)
        {
            $("#elc_employee_rate_profile_id option").each(function() {
                currentItem = $(this).attr("data-type");
                if(currentItem != "Agency" )
                {
                    $(this).removeAttr("selected");
                    $(this).hide();
                    $(this).prop("disabled","disabled");
                }
                else
                {
                    $(this).show();
                    $(this).removeAttr("disabled");
                }
            });
            var rateValue = $("#elc_employee_rate_profile_id").find(":selected").attr("data-rate");
            $("#rateProfilePrice").text("$" + rateValue);
        }
    }

}


export function LoadPage() {
    InitPage("employees", () => {
        const elc_employees = new ElcEmployees();
    });
}
